var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pwc-file-upload",style:(_vm.cPreview)},[(_vm.uploading)?_c('img',{attrs:{"src":require("./assets/loading.svg"),"alt":""}}):_vm._e(),_c('input',{attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.handleSelect}})])}
var staticRenderFns = []

export { render, staticRenderFns }